<script setup>
import { onMounted, ref } from "vue";
import { RouterLink } from "vue-router";
import AppLogo from "./AppLogo.vue";
import AuthenticatedHeader from "./AuthenticatedHeader.vue";
import { getCachedCurrentUser, getCurrentUser } from "../lib/current-user";

const user = ref(getCachedCurrentUser());
defineEmits(["sign-in"]);
const sessionResolved = ref(Boolean(user.value));

onMounted(async () => {
  try {
    user.value = await getCurrentUser();
  } catch {
    user.value = null;
  } finally {
    sessionResolved.value = true;
  }
});
</script>

<template>
  <AuthenticatedHeader v-if="sessionResolved && user" />

  <header
    v-else
    class="sticky top-0 z-50 shrink-0 border-b border-[var(--color-border)] bg-[var(--color-surface)]/95 backdrop-blur-sm"
  >
    <div
      class="public-page-header__inner app-chrome-container flex min-h-[65px] flex-wrap items-center justify-between gap-4 py-3"
    >
      <RouterLink
        v-if="sessionResolved"
        to="/"
        class="flex max-w-full shrink-0 items-center gap-2.5 transition-opacity hover:opacity-80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent-primary)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--color-surface)]"
      >
        <AppLogo :size="36" />
        <div class="type-chrome-brand min-w-0 flex flex-wrap text-white">
          <span>PERMIT</span
          ><span class="text-[var(--brand-accent)]">PILOTT</span>
        </div>
      </RouterLink>

      <div
        v-else
        class="flex max-w-full shrink-0 items-center gap-2.5"
        aria-hidden="true"
      >
        <AppLogo :size="36" />
        <div class="type-chrome-brand min-w-0 flex flex-wrap text-white">
          <span>PERMIT</span
          ><span class="text-[var(--brand-accent)]">PILOTT</span>
        </div>
      </div>

      <RouterLink
        v-if="sessionResolved"
        to="/login"
        class="type-chrome-label ml-auto rounded-sm text-[var(--color-text-muted)] transition-colors hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent-primary)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--color-surface)]"
        @click="$emit('sign-in')"
      >
        Sign in
      </RouterLink>
    </div>
  </header>
</template>
